import React from 'react';
import { useTranslation } from 'react-i18next';
import SEO from '../components/SEO';

const Contact = () => {
  const { t } = useTranslation();

  return (
    <div data-testid="contact-page" style={{ maxWidth: '800px', margin: '0 auto' }}>
      <SEO path="/contact" title="Contact AFHOS" description="Get in touch with AFHOS for membership inquiries, research collaboration, media requests, and partnership opportunities." />
      <div className="page-header">
        <p className="overline">{t('contact.overline')}</p>
        <h1 data-testid="contact-title">{t('contact.title')}</h1>
        <p>{t('contact.subtitle')}</p>
      </div>

      <div className="grid-3" style={{ marginTop: '2rem' }}>
        <div className="card" style={{ textAlign: 'center' }}>
          <i className="fas fa-envelope" style={{ fontSize: '1.5rem', color: 'var(--brand)', marginBottom: '0.75rem', display: 'block' }}></i>
          <h4>{t('contact.generalEnquiries')}</h4>
          <p style={{ color: 'var(--muted)', fontSize: '0.9rem' }}>
            <a href="mailto:info@afhos.africa">info@afhos.africa</a>
          </p>
        </div>
        <div className="card" style={{ textAlign: 'center' }}>
          <i className="fas fa-user-shield" style={{ fontSize: '1.5rem', color: 'var(--brand)', marginBottom: '0.75rem', display: 'block' }}></i>
          <h4>{t('contact.webmaster')}</h4>
          <p style={{ color: 'var(--muted)', fontSize: '0.9rem' }}>
            <a href="mailto:webmaster@afhos.africa">webmaster@afhos.africa</a>
          </p>
        </div>
        <div className="card" style={{ textAlign: 'center' }}>
          <i className="fas fa-globe-africa" style={{ fontSize: '1.5rem', color: 'var(--brand)', marginBottom: '0.75rem', display: 'block' }}></i>
          <h4>{t('contact.website')}</h4>
          <p style={{ color: 'var(--muted)', fontSize: '0.9rem' }}>
            <a href="https://afhos.africa" target="_blank" rel="noreferrer">afhos.africa</a>
          </p>
        </div>
      </div>

      <div className="content-section" style={{ marginTop: '2.5rem' }}>
        <h2>{t('contact.membershipTitle')}</h2>
        <p>{t('contact.membershipDesc')}</p>
        <p>{t('contact.membershipCta')} <a href="/auth">{t('auth.register')}</a></p>
      </div>

      <div className="content-section">
        <h2>{t('contact.collabTitle')}</h2>
        <p>
          {t('contact.collabDesc')} <a href="mailto:info@afhos.africa">info@afhos.africa</a>
        </p>
      </div>

      <div className="content-section">
        <h2>{t('contact.mediaTitle')}</h2>
        <p>
          {t('contact.mediaDesc')} <a href="mailto:info@afhos.africa">info@afhos.africa</a>
        </p>
      </div>
    </div>
  );
};

export default Contact;
